var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "white",
    stroke: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1251 4.03174L8.73438 16.2962L16.1251 12.937V4.03174Z",
    fill: "#8A92B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1251 12.6821L8.73438 16.0413L16.1251 20.4111V12.6821Z",
    fill: "#62688F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5171 16.2962L16.125 4.03174V12.937L23.5171 16.2962Z",
    fill: "#62688F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 20.4111L23.5171 16.0413L16.125 12.6821V20.4111Z",
    fill: "#454A75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73438 16.7971L16.1251 27.2129V21.1642L8.73438 16.7971Z",
    fill: "#8A92B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 21.1642V27.2129L23.5212 16.7971L16.125 21.1642Z",
    fill: "#62688F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEthereum);
export default __webpack_public_path__ + "static/media/ico-ethereum.495b45fd116a580556a696701388b0af.svg";
export { ForwardRef as ReactComponent };